"use strict";

$(function () {
  var ticketModal = $('#createTicketModal');
  if (ticketModal.length === 0) {
    return;
  }
  ticketModal.modal({
    keyboard: true,
    backdrop: 'static',
    show: false
  });
  ticketModal.find('.btn-primary').click(function () {
    var form = ticketModal.find('#taskCreateForm');
    if (form.valid()) {
      form.submit();
    }
  });
  ticketModal.on('show.bs.modal', function (event) {
    var form = $('#taskCreateForm');

    // Очищаем содержимое формы
    form[0].reset();

    // Очищаем валидацию
    form.validate().resetForm();
    form.find('.field-validation-error').children().remove();
    form.find('.input-validation-error').removeClass("input-validation-error");

    // Очищаем прикрепленный файл
    $('#feedbackTicketFile').change();

    // Тип запроса (определяется в вызывающей кнопке)
    var ticketType = $(event.relatedTarget).data('ticket-type');
    if (ticketType != null && ticketType.length > 0) {
      ticketModal.find('.btn-ticket-type[data-ticket-type="' + ticketType + '"]').click();
    }
  });
  ticketModal.find('.btn-ticket-type').click(function () {
    var sender = $(this);
    if (!sender.hasClass('active')) {
      var ticketType = sender.data('ticket-type');
      $('#feedbackTicketType').val(ticketType);
      var placeholder = sender.data('ticket-placeholder');
      $('#feedbackTicketMessage').attr('placeholder', placeholder);
      sender.addClass('active');
      ticketModal.find('.btn-ticket-type').not(sender).removeClass('active');
    }
  });
  $('#btnAttachFeedbackTicketFile').click(function () {
    $('#feedbackTicketFile').click();
  });
  $('#feedbackTicketFile').change(function () {
    var fileName = $(this).val().split('\\').pop();
    $('#feedbackTicketFileName').text(fileName);
    $('#feedbackTicketFileBlock').toggle(fileName.length > 0);
  });
  $('#btnRemoveFeedbackTicketFile').click(function () {
    $('#feedbackTicketFile').val('');
    $('#feedbackTicketFile').change();
  });
});